// extracted by mini-css-extract-plugin
module.exports = {"MovieContainer":"MoviesContainer_MovieContainer__1VuGT"};